<template>
    <div :id="ID_COMPONENTE" class="container-fluid pb-0">
        <div class="row">
            <!-- CATALOGO DE PAGINAS DE INICIO -->
            <div :class="(esParaPaginaWeb) ? 'form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1 deshabilitarSeccionCatalogos' : 'form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1'">
                <h6>Página donde se muestra&nbsp;&nbsp;
                    <i :class="[(filtrosBusqueda.activos.PAGINA_INICIO.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']" 
                        @click="evtActivacionFiltro(filtrosBusqueda.activos.PAGINA_INICIO.llave)"></i>
                </h6>
                <C001PaginaInicio  
                    :class="[false ? 'border border-danger p-0 m-0': 'p-0 m-0']" 
                    v-on:valorParaElPadre="evtCambioPaginaInicio" 
                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                    :idDelInput="filtrosBusqueda.catalogoPaginasDeInicio.ID" 
                    :parametros="filtrosBusqueda.catalogoPaginasDeInicio.parametros" 
                    :valorDefinido="filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido" 
                    :key="filtrosBusqueda.catalogoPaginasDeInicio.KEY + ID_COMPONENTE + filtrosBusqueda.catalogoPaginasDeInicio.contRender"></C001PaginaInicio>
            </div>
            <!-- CATALOGO DE MENUS -->
            <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                <h6>Menú al que pertece&nbsp;&nbsp;
                    <i :class="[(filtrosBusqueda.activos.MENU.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']"
                        @click="evtActivacionFiltro(filtrosBusqueda.activos.MENU.llave)"></i>
                </h6>
                <C004Menus  
                    :class="[false ? 'border border-danger p-0 m-0': 'p-0 m-0']" 
                    v-on:valorParaElPadre="evtCambioMenu" 
                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                    :idDelInput="filtrosBusqueda.catalogoMenus.ID" 
                    :parametros="filtrosBusqueda.catalogoMenus.parametros" 
                    :valorDefinido="filtrosBusqueda.catalogoMenus.valorDefinido" 
                    :key="filtrosBusqueda.catalogoMenus.KEY + ID_COMPONENTE + filtrosBusqueda.catalogoMenus.contRender"></C004Menus>
            </div>
            <!-- TITULO DE SUBMENU -->
            <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                <h6>Título de submenú&nbsp;&nbsp;
                    <i :class="[(filtrosBusqueda.activos.TITULO_SUBMENU.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']"
                        @click="evtActivacionFiltro(filtrosBusqueda.activos.TITULO_SUBMENU.llave)"></i>
                </h6>
                <input v-model="filtrosBusqueda.titulo" type="text" id="titulo_submenu" class="form-control" placeholder="Ingrese el título del submenú" />
            </div>
            <!-- SECCIONES FIELDSET -->
            <div id="filtros-acceso-smpw" class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-0 pt-3 no-gutters">
                <!-- HERENCIA DE SUBMENU -->
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2 pt-1">
                    <fieldset class="scheduler-border row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-1 no-gutters">
                        <legend class="scheduler-border">Submenú al que pertenece&nbsp;&nbsp;
                            <i :class="[(filtrosBusqueda.activos.HERENCIA_SUBMENU.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']"
                                @click="evtActivacionFiltro(filtrosBusqueda.activos.HERENCIA_SUBMENU.llave)"></i>
                        </legend>
                        <!-- TIPO DE SUBMENU MENU -->
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-1">
                            <div class="form-group">
                                <h6>Submenu al que pertece {{ tituloDeSubmenulQuePertenece }}</h6>
                                    <C006Submenus  
                                    class="p-0 m-0" 
                                    v-on:valorParaElPadre="evtCambioSubmenu" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="filtrosBusqueda.catalogoSubmenu.ID" 
                                    :parametros="filtrosBusqueda.catalogoSubmenu.parametros" 
                                    :valorDefinido="filtrosBusqueda.catalogoSubmenu.valorDefinido" 
                                    :key="filtrosBusqueda.catalogoSubmenu.KEY + filtrosBusqueda.catalogoSubmenu.contRender"></C006Submenus>
                            </div>
                            <!-- HIJOS DE SUBMENUS -->
                            <CSelectRecursivo v-if="filtrosBusqueda.catalogoSubmenu.subMenuSeleccionado != null && filtrosBusqueda.catalogoSubmenu.subMenuSeleccionado.SubmenusQueMePertenecen.length > 0"
                                v-on:SeleccionoElemento="evtSeleccionSubmenuHijo"
                                :nodoPrincipal="filtrosBusqueda.catalogoSubmenu.subMenuSeleccionado"
                                :identificadores="{ nodosHijos: 'SubmenusQueMePertenecen', llave: 'SubmenuId', nombre: 'Titulo' }"
                                :texoSingularEnSelect="'un tipo de submenu'"
                                :key="filtrosBusqueda.catalogoSubmenu.hijos.KEY + filtrosBusqueda.catalogoSubmenu.hijos.contRender"></CSelectRecursivo>
                        </div>
                    </fieldset>
                </div>
                <!-- FILTROS PARA ACCESO DE SUBMENU -->
                <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2 pt-1">
                    <div id="filtros-acceso-smpw" class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 no-gutters">
                        <fieldset class="scheduler-border row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-1 no-gutters">
                            <legend class="scheduler-border">Acceso&nbsp;&nbsp;
                                <i :class="[(filtrosBusqueda.activos.ACCESO.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']"
                                    @click="evtActivacionFiltro(filtrosBusqueda.activos.ACCESO.llave)"></i>
                            </legend>
                            <!-- ES DESCARGA -->
                            <div class="col-xs-4 col-sm-6 col-md-6 col-lg-6 pr-2 pl-3 pt-1">
                                <div class="form-inline">
                                    <h6 class="pr-2"><i class="fas fa-file-download"></i>&nbsp;&nbsp;Es para descarga:&nbsp;</h6>
                                    <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                        <label :class="[filtrosBusqueda.esDescarga ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.esDescarga = true">
                                            <input type="radio" name="options" id="radioEsDescarga" autocomplete="off"  checked>Si
                                        </label>
                                        <label :class="[!filtrosBusqueda.esDescarga ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.esDescarga = false">
                                            <input type="radio" name="options" id="radioNoEsDescarga" autocomplete="off" >No
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- SE MUESTRA EN VISOR -->
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2 pl-3 pt-1">
                                <div class="form-inline">
                                    <h6 class="pr-2"><i class="fas fa-eye"></i>&nbsp;&nbsp;Se muestra en visor:</h6>
                                    <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                        <label :class="[filtrosBusqueda.seMuestraEnVisor ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.seMuestraEnVisor = true">
                                            <input type="radio" name="options" id="radioSeMuestraEnVisor" autocomplete="off"  checked>Si
                                        </label>
                                        <label :class="[!filtrosBusqueda.seMuestraEnVisor ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.seMuestraEnVisor = false">
                                            <input type="radio" name="options" id="radioNoSeMuestraEnVisor" autocomplete="off" >No
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <!-- ACCIONES -->
                       <!--  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-1 align-self-end no-gutters">
                            <div class="d-flex justify-content-end">
                                <button  type="button" @click="evtLimpiarFiltros" class="btn btn-primary mr-2"><i class="fas fa-redo-alt"></i>&nbsp;&nbsp;Limpiar</button>
                                <button  type="button" @click="evtRealizarBusqueda" class="btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-1">
                <div class="d-flex justify-content-end">
                    <button type="button" @click="evtLimpiarFiltros" class="btn btn-primary"><i class="fas fa-redo-alt"></i>&nbsp;&nbsp;Limpiar</button>
                    <button v-if="mostrarInicioDeBusqueda" type="button" @click="evtRealizarBusqueda" class="btn btn-primary ml-2"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                </div>
            </div>
            <!-- FILTROS PARA ACCESO DE SUBMENU V1 -->
           <!-- <div id="filtros-acceso-smpw" class="form-group row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-3 no-gutters">
                <fieldset class="scheduler-border row col-xs-5 col-sm-5 col-md-5 col-lg-5 pr-2 pt-1 no-gutters">
                    <legend class="scheduler-border">Acceso&nbsp;&nbsp;
                        <i :class="[(filtrosBusqueda.activos.ACCESO.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']"
                            @click="evtActivacionFiltro(filtrosBusqueda.activos.ACCESO.llave)"></i>
                    </legend>
                    
                    <div class="col-xs-4 col-sm-6 col-md-6 col-lg-6 pr-2 pt-1">
                        <div class="form-inline">
                            <h6 class="pr-2">Es para descarga:&nbsp;</h6>
                            <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                <label :class="[filtrosBusqueda.esDescarga ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.esDescarga = true">
                                    <input type="radio" name="options" id="radioEsDescarga" autocomplete="off"  checked>Si
                                </label>
                                <label :class="[!filtrosBusqueda.esDescarga ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.esDescarga = false">
                                    <input type="radio" name="options" id="radioNoEsDescarga" autocomplete="off" >No
                                </label>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2 pt-1">
                        <div class="form-inline">
                            <h6 class="pr-2">Se muestra en visor:</h6>
                            <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                <label :class="[filtrosBusqueda.seMuestraEnVisor ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.seMuestraEnVisor = true">
                                    <input type="radio" name="options" id="radioSeMuestraEnVisor" autocomplete="off"  checked>Si
                                </label>
                                <label :class="[!filtrosBusqueda.seMuestraEnVisor ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="filtrosBusqueda.seMuestraEnVisor = false">
                                    <input type="radio" name="options" id="radioNoSeMuestraEnVisor" autocomplete="off" >No
                                </label>
                            </div>
                        </div>
                    </div>
                </fieldset>
               
                <div class="form-group col-xs-7 col-sm-7 col-md-7 col-lg-7 pr-2 pt-1 align-self-end no-gutters">
                    <div class="d-flex justify-content-end">
                        <button  type="button" @click="evtLimpiarFiltros" class="btn btn-primary mr-2"><i class="fas fa-redo-alt"></i>&nbsp;&nbsp;Limpiar</button>
                        <button  type="button" @click="evtRealizarBusqueda" class="btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                    </div>
                </div>
           </div> -->
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import catalogos from '@/../static/js/catalogos'
import CSelectRecursivo from '@/components/SICPO/Comun/CSelectRecursivo.vue'
import C006Submenus from '../../Catalogos/C006Submenus.vue'

export default {
    props: {
        ID_COMPONENTE: {
            type: String,
            default: 'filtrosDeBusqueda-submenus-pw'
        },
        // structura de opciones { tipoPagina: tipo pagina de inicio }
        paginaDeSubmenu: {
            type: Object,
            default: () => ({ tipoPagina: 1 })
        },
        esParaSubmenu: {
            type: Boolean,
            default: false
        },
    },
    components: {
        C004Menus: catalogos.SICPO.C004Menus,
        C001PaginaInicio: catalogos.SICPO.C001PaginaInicio,
        CSelectRecursivo,
        C006Submenus
    },
    data() {
        return {
            enumeraciones,
            filtrosBusqueda: {
                titulo: null,
                esDescarga: false,
                seMuestraEnVisor: false,
                catalogoPaginasDeInicio: {
                    ID: 'CPaginaInicio',
                    REF: 'REFPaginaInicio',
                    parametros: { PaginaDeInicioId: null, TipoPaginaId: 1, PaginaWebId: null, PaginaMicrositioId: null, MenuId: null, ConInactivas: false, ConMenus: false, ConPaginasWeb: false, ConPaginasMicrositios: false },
                    valorDefinido: -1,
                    paginaSeleccionada: null,
                    KEY: 'KPaginaInicio',
                    contRender: 0
                },
                catalogoMenus: {
                    ID: 'CMenus',
                    REF: 'REFMenus',
                    parametros: { MenuId: null, SubmenuId: null, TipoPosicionId: null, PaginaWebId: null, PaginaDeInicioId: null, ConInactivos: false, ConSubmenus: false, ConTodosLosSubmenus: false, ConTodasLasPaginasWebDelSubmenu: false, ConPaginasWeb: false, ConPaginasDeInicio: false, ConOrdenamientoDelMenu: false, ConOrdenamientoDelSubmenu: false },
                    valorDefinido: -1,
                    menuSeleccionado: null,
                    KEY: 'KMenus',
                    contRender: 0
                },
                catalogoSubmenu: {
                    ID: 'CSubMenus',
                    REF: 'REFSubMenus',
                    parametros: { SubmenuId: null, MenuId: null, PaginaWebId:null, SubmenuIdDelQuePertenezco:null, SubmenuIdQueMePertenece:null, ConInactivos:false, ConMenu:false, ConMenusLosSubmenus:false, ConSubmenusQueMePertenecen:true, ConTodosLosSubmenusQueMePertenecen: true, ConTodasLasPaginasWebDelSubmenu:false, ConSubmenuDelQueDesciende:true, ConPaginasWeb:false, ConOrdenamiento:false, ConOrdenamientoDeLosSubmenus:false, SoloPermiteSubirContenido:false },
                    valorDefinido: -1,
                    subMenuSeleccionado: null,
                    KEY: 'KSubMenus',
                    contRender: 0,
                    hijos: {
                        KEY: 'KSubMenuHijo',
                        contRender: 0,
                        seleccionado: null,
                        historialDeSeleccion: []
                    }
                },
                activos: {
                    PAGINA_INICIO: { activo: true, llave: 1 },
                    MENU: { activo: true, lave: 2 }, 
                    TITULO_SUBMENU:{ activo: true, llave: 3 },
                    ACCESO: { activo: true, llave: 4 },
                    HERENCIA_SUBMENU: { activo: true, llave: 5 },
                }
            },
            esParaPaginaWeb: false
        }
    },
    methods: {
        evtSeleccionSubmenuHijo: function(evento,objetoElemento) { 
            // se obtiene submenu padre del submenu hijo seleccionado
            let idSubmenuPadreSTR = evento.target.getAttribute('id');
            let idCompuesto = idSubmenuPadreSTR.split('-');
            let idSubmenuPadre = idCompuesto[idCompuesto.length -1];
            //console.log('ID::SUBMENU::',idSubmenuPadre);

            this.filtrosBusqueda.catalogoSubmenu.hijos.seleccionado = (this.campoRequeridoEsValido(objetoElemento)) ? objetoElemento : null;
            // se agrega a historial de seleccion para obtener valor valido mas reciente cuando seleccine vaores incorrectos (en este caso -1)
            // si es un valor valido lo agrega si no lo elimina del historial
            if(this.campoRequeridoEsValido(this.filtrosBusqueda.catalogoSubmenu.hijos.seleccionado)) {
                this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion.push(this.filtrosBusqueda.catalogoSubmenu.hijos.seleccionado);
            }
            else {
                /* this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion.pop(); */
                const ELEMENTO_SELECCIONADOS = this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion.filter(sh => sh.SubmenuAlQuePertenezco.SubmenuId == idSubmenuPadre);
                const ELEMENTO_SELECCIONADO = ELEMENTO_SELECCIONADOS[0];
                //console.log('ELEMENTO_SELECCIONADO::',ELEMENTO_SELECCIONADO);

                if(this.campoRequeridoEsValido(ELEMENTO_SELECCIONADO)) {
                    // elimina los historiales de submenus hijos
                    let indexDeElemento = this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion.findIndex(sh => sh.SubmenuId == ELEMENTO_SELECCIONADO.SubmenuId);
                    indexDeElemento ++; // metodo slice termina uno antes del parametro que se le mande como final por eso se suma 1
                    //console.log('indexDeElemento::',indexDeElemento);
                    this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion = this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion.slice(0,indexDeElemento);

                    // elimina el historial de los submenus con el mismo submenu padre
                    this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion = this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion
                        .filter(sh => sh.SubmenuAlQuePertenezco.SubmenuId != ELEMENTO_SELECCIONADO.SubmenuAlQuePertenezco.SubmenuId);
                }
            }

            console.log('evtSeleccionSubmenuHijo::',this.filtrosBusqueda.catalogoSubmenu.hijos.seleccionado);
        },
        obtenerUltimaSeleccionValidaHijosDeSubmenu: function() {
            const ULTIMO_INDEX = (this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion.length - 1);
            let ultimaSeleccionValida = this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion[ULTIMO_INDEX];
            return ultimaSeleccionValida;
        },
        evtCambioSubmenu: function(evento, subMenuObjeto) {
            this.filtrosBusqueda.catalogoSubmenu.valorDefinido = parseInt(evento.target.value);
            this.filtrosBusqueda.catalogoSubmenu.subMenuSeleccionado = subMenuObjeto;

            // se limpia el valor del submenu hijo en caso de que tenga uno asignado
            this.filtrosBusqueda.catalogoSubmenu.hijos.seleccionado = null; 
            this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion = [];
            console.log('subMenuObjeto::',subMenuObjeto);
        }, 
        evtLimpiarFiltros: function() {
            this.filtrosBusqueda.titulo = null;
            this.filtrosBusqueda.esDescarga = false;
            this.filtrosBusqueda.seMuestraEnVisor = false;
            this.filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido = -1;
            this.filtrosBusqueda.catalogoMenus.valorDefinido = -1;
            this.filtrosBusqueda.activos.PAGINA_INICIO.activo = true;
            this.filtrosBusqueda.activos.MENU.activo = true;
            this.filtrosBusqueda.activos.TITULO_SUBMENU.activo = true;
            this.filtrosBusqueda.activos.ACCESO.activo = true;
            this.filtrosBusqueda.catalogoSubmenu.valorDefinido = -1;
            this.filtrosBusqueda.catalogoSubmenu.subMenuSeleccionado = null;
            this.filtrosBusqueda.catalogoSubmenu.hijos.seleccionado = null;
            this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion = [];
            // renderizar catalogos
            this.filtrosBusqueda.catalogoPaginasDeInicio.contRender ++;
            this.filtrosBusqueda.catalogoMenus.contRender ++;
            this.filtrosBusqueda.catalogoSubmenu.contRender ++;
        },
        evtRealizarBusqueda: function() {
            const { titulo, esDescarga, seMuestraEnVisor, catalogoPaginasDeInicio, catalogoMenus, activos } = this.filtrosBusqueda;
            const { PAGINA_INICIO, MENU, TITULO_SUBMENU, ACCESO, HERENCIA_SUBMENU } = activos;
            const FILTROS_BUSQUEDA = {
                paginaInicioId: this.campoRequeridoEsValido(catalogoPaginasDeInicio.valorDefinido) && PAGINA_INICIO.activo ? catalogoPaginasDeInicio.valorDefinido : null,
                menuId: this.campoRequeridoEsValido(catalogoMenus.valorDefinido) && MENU.activo ? catalogoMenus.valorDefinido : null,
                tituloSubmenu: this.campoRequeridoEsValido(titulo) && TITULO_SUBMENU.activo ? titulo : null,
                submenuAlQuePertenece: HERENCIA_SUBMENU.activo ? this.obtenerSubmenuAlQuePertenece() : null,
                esDescarga: this.campoRequeridoEsValido(esDescarga) && ACCESO.activo ? esDescarga : null,
                seMuestraEnVisor: this.campoRequeridoEsValido(seMuestraEnVisor) && ACCESO.activo ? seMuestraEnVisor : null,
            }
            this.$emit('BusquedaDeSubmenus', FILTROS_BUSQUEDA);
        },
        obtenerSubmenuAlQuePertenece: function() {
            let submenu = null;
            if(this.campoRequeridoEsValido(this.filtrosBusqueda.catalogoSubmenu.valorDefinido)) {
                const ULTIMA_SELECCION_SM_HIJO = this.obtenerUltimaSeleccionValidaHijosDeSubmenu();
                //submenu = (this.campoRequeridoEsValido(ULTIMA_SELECCION_SM_HIJO)) ? ULTIMA_SELECCION_SM_HIJO.SubmenuId : this.filtrosBusqueda.catalogoSubmenu.valorDefinido;
                submenu = (this.campoRequeridoEsValido(ULTIMA_SELECCION_SM_HIJO)) ? ULTIMA_SELECCION_SM_HIJO : this.filtrosBusqueda.catalogoSubmenu.subMenuSeleccionado;
            }
            return submenu;
        },
        evtActivacionFiltro: function(tipoDeFiltro) { 
            const ESTADO_DE_FILTROS = Object.values(this.filtrosBusqueda.activos);
            let filtro = ESTADO_DE_FILTROS.find(fb => fb.llave == tipoDeFiltro);
            if(this.campoRequeridoEsValido(filtro)) {
                filtro.activo = !filtro.activo;
            }
        },
        evtCambioPaginaInicio: function(evento) {
            this.filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido = parseInt(evento.target.value);
            const ES_MENU_VALIDO = this.campoRequeridoEsValido(this.filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido);
            // se actualiza catalogo de menus
            this.filtrosBusqueda.catalogoMenus.valorDefinido = -1;
            this.filtrosBusqueda.catalogoMenus.parametros.PaginaDeInicioId = (ES_MENU_VALIDO) ? this.filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido : null;
            this.filtrosBusqueda.catalogoMenus.contRender ++;

            // se actualiza catalogo de submenus
            this.filtrosBusqueda.catalogoSubmenu.parametros.MenuId = null;
            this.filtrosBusqueda.catalogoSubmenu.valorDefinido = -1;        
            this.filtrosBusqueda.catalogoSubmenu.contRender ++;
            this.filtrosBusqueda.catalogoSubmenu.subMenuSeleccionado = null;

            // se limpia el valor del submenu hijo en caso de que tenga uno asignado
            this.filtrosBusqueda.catalogoSubmenu.hijos.seleccionado = null; 
            this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion = [];
        },
        evtCambioMenu: function(evento, menuObj) {
            this.filtrosBusqueda.catalogoMenus.valorDefinido = parseInt(evento.target.value);

            // se actualiza catalogo de submenus
            this.filtrosBusqueda.catalogoSubmenu.parametros.MenuId = this.campoRequeridoEsValido(this.filtrosBusqueda.catalogoMenus.valorDefinido) ? this.filtrosBusqueda.catalogoMenus.valorDefinido : null;
            this.filtrosBusqueda.catalogoSubmenu.valorDefinido = -1;        
            this.filtrosBusqueda.catalogoSubmenu.contRender ++;
            this.filtrosBusqueda.catalogoSubmenu.subMenuSeleccionado = null;

            // se limpia el valor del submenu hijo en caso de que tenga uno asignado
            this.filtrosBusqueda.catalogoSubmenu.hijos.seleccionado = null; 
            this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion = [];
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    created() {
        const PAGINA_OFICIAL_ID = 1;
        if(this.paginaDeSubmenu.tipoPagina == PAGINA_OFICIAL_ID) {
            this.filtrosBusqueda.catalogoPaginasDeInicio.parametros.TipoPaginaId = this.paginaDeSubmenu.tipoPagina;
            this.filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido = PAGINA_OFICIAL_ID;

            this.$nextTick(() => {
                // se actualiza catalogo de menus
                this.filtrosBusqueda.catalogoMenus.valorDefinido = -1;
                this.filtrosBusqueda.catalogoMenus.parametros.PaginaDeInicioId = PAGINA_OFICIAL_ID;
                this.filtrosBusqueda.catalogoMenus.contRender ++;
                this.esParaPaginaWeb = true;
            });
        }
    },
    computed: {
        tituloDeSubmenulQuePertenece() {
            return (this.campoRequeridoEsValido(this.obtenerSubmenuAlQuePertenece())) ? ` [ ${ this.obtenerSubmenuAlQuePertenece().Titulo } ]` : '';
        },
        mostrarInicioDeBusqueda() {
            return (
                    (this.campoRequeridoEsValido(this.filtrosBusqueda.catalogoMenus.valorDefinido) && this.filtrosBusqueda.activos.MENU.activo) 
                        ||
                    (this.filtrosBusqueda.activos.HERENCIA_SUBMENU.activo && this.campoRequeridoEsValido(this.obtenerSubmenuAlQuePertenece()))
                   )
        }
    }
}
</script>
<style scoped>
.deshabilitarSeccionCatalogos {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

.check-activacion-filtros {
    cursor: pointer;
}

#filtros-acceso-smpw fieldset.scheduler-border {
    border: 1px groove #ddd !important;
    padding: 0 1.4em 1.4em 1.4em !important;
    margin: 0 0 1.5em 0 !important;
    -webkit-box-shadow:  0px 0px 0px 0px #000;
            box-shadow:  0px 0px 0px 0px #000;
}

#filtros-acceso-smpw legend.scheduler-border {
    font-size: 1.2em !important;
    font-weight: bold !important;
    text-align: left !important;
    width:auto;
    padding:0 10px;
    border-bottom:none;
}

.btn-secondary:not(:disabled):not(.disabled).active, 
.btn-secondary:not(:disabled):not(.disabled):active, .show > #opciones-toggle .btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

.btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
}

.btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/Submenus/CFiltrosDeBusquedaSubMenus.vue